import { Loader } from '../../components';
import { memo, useEffect } from 'react';
import { useActiveLoan } from '../ActiveLoan/useActiveLoan';
import { useApplication } from '../../hooks/webapi';
import RepaymentDefault from './RepaymentDefault';
import RepaymentOverdue6Or8 from './RepaymentOverdue6Or8';
import useLatestLoan from '../../hooks/webapi/useLatestLoan';

export default memo(function Repayment() {
  const { isOverdue, isBrokenAgreement } = useActiveLoan();
  const { application, fetchApplication } = useApplication();
  const {
    latestLoan,
    fetchLatestLoan,
    selectedLoanExtension,
    setSelectedLoanExtension,
  } = useLatestLoan();

  useEffect(() => {
    if (selectedLoanExtension) setSelectedLoanExtension(undefined);
  }, [selectedLoanExtension]);

  useEffect(() => {
    const prefetch = async () => {
      try {
        await fetchLatestLoan();
        await fetchApplication();
      } catch {}
    };

    prefetch();
  }, [fetchApplication, fetchLatestLoan]);

  if (!application || !latestLoan) return <Loader />;

  if (isOverdue || isBrokenAgreement) return <RepaymentOverdue6Or8 />;

  return <RepaymentDefault />;
});
